<template>
    <v-container>
        <div id="orderHeader" class="mt-3 mb-3">
            <h2 class="pageTitle hideMobile" id="pageTitle">{{txc.order_detail_title}}</h2>
            <v-layout row>
                <v-flex xs12>
                    <div class="cardSectionTitle" id="backToOrders">
                        <a href="#/orders" @click="hideDetails()">&laquo; {{sharedStrings.generic.back}}</a>
                    </div>
                </v-flex>
                <v-flex xs12 class="text-right">
                    <div id="printButton" class="no-print">
                        <button small flat outline class="secondary-hit right" @click="printOrder()">
                            <span class="icon icon-print"> </span>
                            {{sharedStrings.generic.print}}
                        </button>
                    </div>
                </v-flex>
            </v-layout>
        </div>
        <div id="orderStatus"></div>

        <div class="orderDetailCard">
            <v-flex class="orderDetailInfo">
                <v-layout row>
                    <v-flex class="mb-2" xs-12 lg6>
                        <div id="orderNumber"><strong>{{txc.order_number}}: {{ordernumber}}</strong></div>
                        <div id="orderDate">{{txc.date}}: {{order.orderInfo.orderDate}}</div>
                    </v-flex>
                    <v-flex class="mb-2 text-right" xs-12 lg6>
                        <div class="orderStatus">{{txc.order_status}}: <span class="text-uppercase">{{statusTranslate(order.orderInfo.orderStatus)}}</span>
                        </div>
                        <div class="returnOrder no-print" v-if="canReturn"><a v-bind:href="txc.return_order_url" target="_blank">{{txc.return_order_url_title}}</a>
                        </div>
                    </v-flex>
                </v-layout>
                <div class="orderAddress">
                    <strong>{{txc.shipped_to}}:</strong>
                    <div v-html="order.orderInfo.concatenatedAddress">{{order.orderInfo.concatenatedAddress}}</div>
                </div>
                <!--                <div>Tracking #: {{order.tracking}}</div>-->
                <!--                <div v-if="order.tracking.length > 0" class="trackingInfo">-->
                <!--                    <p><strong>{{txc.tracking_number}}:</strong>-->
                <!--                       <span v-for="item in order.tracking"><a @click="showTracking(order)">{{item.TrackNumber}}</a><br /></span>-->
                <!--                    </p>-->
                <!--                </div>-->
                <hr>
                <loader v-show="processing"/>
                <div class="orderItemDetails">
                    <v-layout row wrap class="orderLineItemHeader doubleUnderline">
                        <v-flex class="md5 xs5 flex">{{txc.product}}</v-flex>
                        <v-flex class="xs2 flex text-right showMobile">{{sharedStrings.generic.quantity}}</v-flex>
                        <v-flex class="md2 xs5 flex text-right ">{{txc.price}}</v-flex>
                        <v-flex class="md2 flex text-right hideMobile">{{sharedStrings.generic.quantity}}</v-flex>
                        <v-flex class="md3 flex text-right hideMobile">{{txc.total}}</v-flex>
                    </v-layout>
                    <v-layout row wrap class="orderLineItem" v-for="(lineItem,i) in order.orderLineItems" :key="`A-${i}`">
                        <v-flex class="md5 xs5 flex">
                            <div class="">{{lineItem.description}}</div>
                            <div class="">{{lineItem.sku}}</div>
                            <div class="">{{txc.psv}}: {{lineItem.psv}}</div>
                        </v-flex>
                        <v-flex class="xs2 flex text-right showMobile">{{lineItem.qty}}</v-flex>
                        <v-flex class="text-right xs5 md2 flex">
                            <div>{{lineItem.price}}</div>
                        </v-flex>
                        <v-flex class="text-right md2 flex hideMobile">{{lineItem.qty}}</v-flex>
                        <v-flex class="text-right md3 flex hideMobile">{{lineItem.total}}</v-flex>
                    </v-layout>
                </div>
                <hr>
                <div id="totals">
                    <div class="orderSubtotal">
                        <strong>{{txc.subtotal}}: {{order.orderTotals.orderSubtotal}}</strong>
                    </div>
                    <div class="orderShipping">
                        <strong>{{txc.shipping}}: {{order.orderTotals.orderShipping}}</strong>
                    </div>
                    <div class="orderTax">
                        <strong>{{txc.tax}}: {{order.orderTotals.orderTax}}</strong>
                    </div>
                    <div class="orderTotal">
                        <strong>{{txc.total}}: {{order.orderTotals.orderTotal}}</strong>
                    </div>
                </div>
                <hr/>
                <v-layout row wrap>
                    <v-flex class="sm4 xs12 mb-2">
                        <div><strong>{{txc.payment_information}}</strong></div>
                        <div v-if="order.ccInfo.ccType!=''">{{order.ccInfo.ccType}}</div>
                        <div v-else>&mdash;</div>
                        <!-- Future Addition
                        <div>{{order.ccInfo.ccNumber}}</div>
                        <div>{{order.ccInfo.ccExpMonth}} / {{order.ccInfo.ccExpYear}}</div>
                        -->
                    </v-flex>
                    <v-flex class="sm4 xs12 mb-2">
                        <div><strong>{{txc.tracking_number}}</strong></div>
                        <div v-for="(item, index) in trackingInfo" :key="index">
                            <div v-if="!marketConfig.trackingLinkUnavailable.includes(item.Carrier)"><a @click="showTracking(item.TrackURL)">{{item.TrackNumber}}</a></div>
                            <div v-else>{{item.TrackNumber}}<span v-if="item.TrackNumber!==''">&mdash;</span></div>
                        </div>
                    </v-flex>
                    <v-flex class="sm4 xs12 mb-2">
                        <div><strong>{{txc.shipping_method}}</strong></div>
                        <div v-if="order.shippingDescription!=''">{{order.shippingDescription}}</div>
                        <div v-else>&mdash;</div>
                    </v-flex>
                </v-layout>
            </v-flex>
        </div>
    </v-container>
</template>

<script>
import {ProfileService} from '@nuskin/ns-account';
import {CurrencyService} from '@nuskin/ns-shop';
import Loader from '../components/Loader';
import * as ruleSet from '../repositories/globalRules.js';
import {mapGetters} from 'vuex';
import profileUtils from '../repositories/profileUtils';
import orderdetail from '../helpers/components/orderdetail';

export default {
    name: 'OrderDetail',
    props: {
        ordernumber: String
    },

    data() {
        return {
            trackingInfo: [],
            order: {
                orderTotals: {
                    orderSubtotal: '',
                    orderShipping: '',
                    orderTax: '',
                    orderTotal: ''
                },
                orderLineItems: [],
                orderInfo: {
                    orderStatus: '',
                    orderChannel: '',
                    orderDate: ''
                },
                tracking: [],
                shippingDescription: '',
                ccInfo: {
                    ccType: '',
                    ccNumber: '',
                    ccExpMonth: '',
                    ccExpYear: ''
                }
            },
            processing: false,
            ruleSet,
            canReturn: false
        };
    },
    components: {
        Loader
    },
    computed: {
        ...mapGetters({
            languageLoggedIn: 'languageLoggedIn',
            marketLoggedIn: 'marketLoggedIn',
            txc: 'translationsOrderHistory',
            sharedStrings: 'sharedStrings',
            getTrackingInfo: 'getTrackingInfo',
            getJapanStates: 'getJapanStates',
            marketConfig: 'marketConfig'
        })
    },
    methods: {
        hideDetails() {
            orderdetail.hideDetails(this,profileUtils);
        },
        showTracking(trackURL) {
            orderdetail.showTracking(profileUtils,trackURL);
        },
        printOrder() {
            orderdetail.printOrder(this,profileUtils);
        },
        canOrderBeReturned(date) {
            orderdetail.canOrderBeReturned(this,date);
        },
        statusTranslate(status) {
            return orderdetail.statusTranslate(this, status);
        }
    },

    mounted: function () {
        orderdetail.mounted(this,ProfileService,CurrencyService);
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    .trackingInfo {
        padding-top: 20px;
    }

    .mdstrong {
        font-weight: 600;
    }

    .overline {
        border-top: 1px solid #63666a;
    }

    .orderCard,
    .orderDetailCard {
        border: 1px solid #c1c1c1;
        padding: 10px 20px;
        margin: 5px 0;
        background-color: #fff;
        line-height: 1.5em;
    }

    #orderInfoHeader {
        display: none;
        border-top: 1px solid #c1c1c1;
    }

    #backToOrders,
    #backToOrders a {
        color: #333;
        text-decoration: none;
    }

    .orderAddress {
        padding-top: 10px;
    }

    .orderItemImage {
        margin-right: 1em;
    }

    #totals {
        text-align: right;
    }

    #orderItemDetails {
        margin-bottom: 10px;
    }

    .orderLineItem {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        padding: 10px;
    }

    .orderLineItemHeader {
        display: flex;
        flex-direction: row;
        flex-grow: 1;
        align-items: flex-end;
        padding: 10px;
        font-weight: 600;
    }

    .orderLineItem:nth-of-type(odd) {
        background-color: #f6f7f7;
    }

    .orderLineItemHeader .orderItemQuantity, .orderLineItem .orderItemQuantity {
        width: 8%;
        padding: 10px 15px;
        text-align: right;
    }

    .orderLineItemHeader .orderItemInfo, .orderLineItem .orderItemInfo {
        width: 38%;
        padding: 10px 15px;
    }

    .orderLineItemHeader .orderUnitPrice, .orderLineItem .orderUnitPrice {
        width: 23%;
        padding: 10px 15px;
        text-align: right;
    }

    .orderLineItemHeader .orderItemPrice, .orderLineItem .orderItemPrice {
        text-align: right;
        width: 23%;
        padding: 10px 15px;
    }

    @media screen and (max-width: 767px) {
        #orderHistoryPage {
            max-width: 760px;
            margin: 10px 5%;
        }

        #orderFilters input,
        #orderFilters select {
            width: 100%;
            margin: 0px auto;
        }

        #orderFilters {
            flex-direction: column;
        }

        #historyFilters {
            flex-direction: column;
            width: 100%;
        }

        #historyFilters div {
            width: 100%;
            margin: 0 0 10px;
        }

        .detailSection {
            text-align: right;
        }
    }

    @media screen and (max-width: 374px) {
        body {
            background: #f6f7f7;
            font-size: 14px;
        }
    }

    @media print {
        body {
            max-width: 800px;
        }

        #orderHeader,
        #orderFooter,
        .sidebar-sticky,
        ns-header-wrapper,
        .QSIFeedbackButton
        {
            display: none !important;
        }

        .detailSection {
            display: none;
        }

        .orderCard {
            border-bottom: none;
            border-top: none;
            margin: 0;
        }

        .orderCard:last-child {
            border-bottom: 1px solid #c1c1c1;
        }

        .orderCard:nth-of-type(odd) {
            background-color: #f6f7f7;
        }

        .orderInfo {
            display: flex;
            flex-direction: row;
            align-content: space-between;
            width: 100%;
        }

        #orderInfoHeader {
            display: block;
        }

        .orderInfo div {
            width: 20%;
            text-align: right;
        }

        .orderInfo span {
            display: none;
        }
    }
</style>
